import Cookies from 'js-cookie'
import { Message } from 'element-ui'
const smsCodeTimerKey = 'ai-interview-sms-code-timer'
export function getSmsTimer() {
  return Cookies.get(smsCodeTimerKey)
}
export function setSmsTimer(value) {
  if (value <= 0) return
  Cookies.set(smsCodeTimerKey, value, { expires: 1 })
  return Cookies.get(smsCodeTimerKey)
}
export function countSmsTimer() {
  const cur = Cookies.get(smsCodeTimerKey)
  if (cur == null || cur <= 0) return
  Cookies.set(smsCodeTimerKey, cur - 1, { expires: 1 })
  return Cookies.get(smsCodeTimerKey)
}
export function removeSmsTimer() {
  Cookies.remove(smsCodeTimerKey)
  return null
}